/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { PrescriptionPatientDto } from './PrescriptionPatientDto';
import {
    PrescriptionPatientDtoFromJSON,
    PrescriptionPatientDtoFromJSONTyped,
    PrescriptionPatientDtoToJSON,
    PrescriptionPatientDtoToJSONTyped,
} from './PrescriptionPatientDto';

/**
 * 
 * @export
 * @interface SearchedPatientsForNewPrescriptionResponseDto
 */
export interface SearchedPatientsForNewPrescriptionResponseDto {
    /**
     * List of patients
     * @type {Array<PrescriptionPatientDto>}
     * @memberof SearchedPatientsForNewPrescriptionResponseDto
     */
    items: Array<PrescriptionPatientDto>;
    /**
     * Pagination information
     * @type {PaginationDto}
     * @memberof SearchedPatientsForNewPrescriptionResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the SearchedPatientsForNewPrescriptionResponseDto interface.
 */
export function instanceOfSearchedPatientsForNewPrescriptionResponseDto(value: object): value is SearchedPatientsForNewPrescriptionResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function SearchedPatientsForNewPrescriptionResponseDtoFromJSON(json: any): SearchedPatientsForNewPrescriptionResponseDto {
    return SearchedPatientsForNewPrescriptionResponseDtoFromJSONTyped(json, false);
}

export function SearchedPatientsForNewPrescriptionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchedPatientsForNewPrescriptionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(PrescriptionPatientDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function SearchedPatientsForNewPrescriptionResponseDtoToJSON(json: any): SearchedPatientsForNewPrescriptionResponseDto {
    return SearchedPatientsForNewPrescriptionResponseDtoToJSONTyped(json, false);
}

export function SearchedPatientsForNewPrescriptionResponseDtoToJSONTyped(value?: SearchedPatientsForNewPrescriptionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(PrescriptionPatientDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

